import { defineComponent, createElementBlock, openBlock, renderSlot, createCommentVNode, normalizeClass, toDisplayString } from "vue";
const _hoisted_1 = { class: "border border-p-gray-30 bg-surface px-6 pt-6" };
const titleClass = "text-xl font-medium leading-none text-p-purple-60";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PCard" },
  __name: "p-card",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        renderSlot(_ctx.$slots, "title", { titleClass }, () => [
          __props.title ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(titleClass)
          }, toDisplayString(__props.title), 1)) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "default")
      ]);
    };
  }
});
export {
  _sfc_main as _
};
